// extracted by mini-css-extract-plugin
module.exports = {"extraBar":"CustomHeader_extraBar__3j35W"};